import { containsV1inPath, getQueryParamsAndQueryString, } from '@thoughtspot/env-flags';
export const DEFAULT_TARGET = '_self';
export const openNavLink = (navLink, isReactshellEnabled, getCurrentPathByLocationHash) => {
    const { queryString } = getQueryParamsAndQueryString();
    if (getCurrentPathByLocationHash(false) === navLink.uri)
        window.location.reload();
    else if (isReactshellEnabled &&
        containsV1inPath() &&
        navLink.isReactShellSupported) {
        window.open(`/${queryString}#${navLink.uri}`, navLink.linkTarget);
        return;
    }
    window.open(`${window.location.pathname}${queryString}#${navLink.uri}`, navLink.linkTarget);
};
export const handleClick = (config, isCurrentApplication, getCurrentPathByLocationHash, isReactshellEnabled) => {
    if (config.target?.uri) {
        config.target.linkTarget = isCurrentApplication
            ? '_self'
            : config.target.linkTarget;
        openNavLink(config.target, isReactshellEnabled, getCurrentPathByLocationHash);
    }
    else {
        config.target.callback();
    }
};
//# sourceMappingURL=nav-config.util.js.map